import React, { Component } from "react";
import {
	Row,
	Col,
	Button,
	Modal,
	Typography,
	Form,
	Input,
	message,
	Spin,
	InputNumber,
	Divider,
} from "antd";
import {
	PlusOutlined,
	UploadOutlined,
	DeleteOutlined,
} from "@ant-design/icons";

import Decimal from "decimal.js";

import "../../../../Styles/Modules/CRM/Clientes.scss";
import { Uploader } from "../../../Widgets/Uploaders";
import { useNavigate, useParams } from "react-router-dom";

const { Title } = Typography;
const axios = require("axios").default;

class ModalAdicionales extends Component {

	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			propiedad: null,
			monto_total: 0,
			monto_venta_propiedad: 0,
		};
	}

	refModalAdicionales = React.createRef();

	componentDidMount() {
		axios.defaults.headers.common["Authorization"] = sessionStorage.getItem("token");
		if (this.props.propiedad_id) this.getPropiedad();
	}

	/**
	 * @memberof ModalAdicionales
	 * @method getPropiedad
	 * @description Obtiene la informacion de una propiedad
	 */
	getPropiedad = () => {
		this.setState({ loading: true });
		axios
			.get(`/propiedades/${this.props.propiedad_id}`, {
				params: {
					id: this.props.propiedad_id,
				},
			})
			.then((response) => {
				let propiedad = response.data;
				this.setState({
					monto_venta_propiedad: propiedad.monto_venta,// monto base
					monto_total : propiedad.monto_total, // = monto base + adicionales + otros?
				});
				this.refModalAdicionales.current?.setFieldsValue({
					...propiedad,
					adicionales: propiedad.adicionales?.map(
						({ documentos, ...adicional }) => ({
							...adicional,
							documentos: documentos.map((file, index) => ({
								uid: file.file,
								name: file.name,
								status: "done",
								fromDB: true,
								url:
									axios.defaults.baseURL +
									"/propiedades/" +
									this.props.propiedad_id +
									"?adicional=" +
									file.file +
									"&adicional_id=" +
									adicional._id +
									"&Authorization=" +
									sessionStorage.getItem("token"),
							})),
						})
					),
				});
			})
			.catch((error) => {
				message.error("Error al traer la propiedad");
				console.log(error);
			})
			.finally(() => this.setState({ loading: false }));
	};

	/**
	 * @memberof ModalAdicionales
	 * @method onFinish
	 * @description Se ejecuta al dar enter al formulario
	 *
	 */
	onFinish = (values) => {
		const formData = new FormData();
		formData.appendMultiple({});

		values.adicionales?.forEach((e, index) => {
			formData.append(
				`adicionales`,
				JSON.stringify({
					_id: e._id,
					nombre: e.nombre,
					costo: e.costo,
					documentos: e.documentos?.map((f) => f.name),
				})
			);

			if (e.documentos?.length > 0)
				for (const archivo of e.documentos) {
					if (!archivo.fromDB)
						formData.append("adicionales_documentos", archivo, archivo.name);
				}
		});

		if(values.adicionales.length === 0){
			formData.appendMultiple({ deleteAllAdicionales: true });
		}

		if (this.props.propiedad_id) {
			this.updatePropiedad(formData);
		}
	};

	updatePropiedad = (values) => {
		this.setState({ loading: true });
		axios
			.put("/propiedades/" + this.props.propiedad_id, values)
			.then((response) => {
				message.success("Propiedad actualizada");
				this.props.onClose();
			})
			.catch((error) => {
				console.log(error.response);
				message.error("Error al actualizar la propiedad");
			})
			.finally(() => this.setState({ loading: false }));
	};

	onValuesFormChange = (valuesChange, allValues) => {
		if (valuesChange.adicionales) {

			let totalAdicionales = Array.isArray(allValues.adicionales)
				? allValues.adicionales.reduce(
						(previousValue, adicional) =>
							previousValue.add(Decimal(adicional?.costo ?? 0)),
						Decimal(0)
					)
				: Decimal(0);

			this.setState({
				monto_total: Decimal(this.state.monto_venta_propiedad)
					.add(totalAdicionales)
					.toDecimalPlaces(2)
					.toNumber(),
			});
		}
	}

	onDeleteElement = (elementoEliminado) => {
		let monto_total = Decimal(this.state.monto_total);
		if(!elementoEliminado?.costo) return
		monto_total = monto_total.sub(elementoEliminado.costo)

		this.setState({
			monto_total
		})
		
	}

	render() {

		return (
			<Form
				layout="vertical"
				name="form-propiedads"
				id="form-propiedads"
				ref={this.refModalAdicionales}
				onFinish={this.onFinish}
				onValuesChange={this.onValuesFormChange}
				initialValues={{
					tipo: 1,
				}}
			>
				<Spin spinning={this.state.loading}>
					<Row gutter={[16, 16]}>
						<Col xs={24}>
							<Divider>Aspectos Adicionales</Divider>
						</Col>
						<Col xs={24} className="propiedades-adicionales">
							<Form.List name="adicionales">
								{(fields, { add, remove }) => (
									<>
										<Row gutter={[16, 16]}>
											<Col span={8}>
												<Title level={5}>Nombre</Title>
											</Col>
											<Col span={8}>
												<Title level={5}>Cantidad / Monto</Title>
											</Col>
											<Col span={5}>
												<Title level={5}>Evidencia</Title>
											</Col>
										</Row>
										<Row gutter={[16, 16]} style={{ marginTop: "0.5em" }}>
											{fields.map(({ key, name, ...restField }, index) => (
												<>
													<Form.Item nname={[name, "_id"]} hidden />

													<Col span={8}>
														<Form.Item
															{...restField}
															name={[name, "nombre"]}
															rules={[
																{
																	required: true,
																	message: "Por favor, ingrese el nombre",
																},
															]}
														>
															<Input placeholder="Nombre" />
														</Form.Item>
													</Col>
													<Col span={8}>
														<Form.Item
															{...restField}
															name={[name, "costo"]}
															rules={[
																{
																	required: true,
																	message: "Por favor, ingrese el costo",
																},
															]}
														>
															<InputNumber
																disabled={false}
																min={0.01}
																className="width-100"
																decimalSeparator=","
																formatter={(value) =>
																	`$ ${value}`.replace(
																		/\B(?=(\d{3})+(?!\d))/g,
																		","
																	)
																}
																parser={(value) =>
																	value ? value.replace(/\$\s?|(,*)/g, "") : 0
																}
															/>
														</Form.Item>
													</Col>
													<Col span={6} style={{ alignSelf: "center" }}>
														<Form.Item
															className="width-100"
															name={[name, "documentos"]}
															valuePropName={"fileList"}
															getValueFromEvent={(e) => {
																if (Array.isArray(e)) {
																	console.log("e");
																	return e.filter((f) => {
																		return f instanceof File || f.fromDB
																			? true
																			: false;
																	});
																}
																return e.fileList.filter((f) => {
																	return f instanceof File || f.fromDB
																		? true
																		: false;
																});
															}}
														>
															<Uploader
																{...(this.props.propiedad_id
																	? {
																			onRemove: (e) => {
																				axios.put(
																					"/propiedades/" +
																						this.props.propiedad_id,
																					{
																						adicional: e.uid,
																						index,
																					}
																				);
																			},
																		}
																	: {})}
															>
																<Button
																	icon={<UploadOutlined />}
																	block
																	size="small"
																>
																	Subir
																</Button>
															</Uploader>
														</Form.Item>
													</Col>
													<Col span={2} align="end">
														<Button
															danger
															icon={<DeleteOutlined />}
															onClick={() => {
																const elementoEliminado = (this.refModalAdicionales.current.getFieldValue('adicionales'))[name];
																this.onDeleteElement(elementoEliminado)
																remove(name)
															}}
														/>
													</Col>
												</>
											))}
										</Row>

										<Divider
											style={{
												marginTop: "0.5em",
												marginBottom: "0.5em",
											}}
										/>
										<Row
											gutter={[16, 16]}
											style={{
												marginTop: "0.5em",
												marginBottom: "0.5em",
											}}
										>
											<Col span={8}>
												<Title level={5}>Monto Total</Title>
											</Col>
											<Col span={9}>
												<Title level={4}>
													{this.state.monto_total?.toLocaleString( "en-US", { style: "currency", currency: "USD" } )}
												</Title>
											</Col>
										</Row>
												

										<Form.Item>
											<Button
												type="dashed"
												onClick={() => add()}
												block
												icon={<PlusOutlined />}
											>
												Agregar Adicional
											</Button>
										</Form.Item>
									</>
								)}
							</Form.List>
						</Col>
					</Row>
				</Spin>
			</Form>
		);
	}
}

export default function (props) {
	const { visible = false, onClose = () => {}, propiedad_id } = props;

	// const  =
	return (
		<Modal
			visible={visible}
			onCancel={onClose}
			title={propiedad_id ? "Editar Propiedad" : "Nueva Propiedad"}
			closable={true}
			destroyOnClose={true}
			zIndex={1000}
			cancelText={"Cancelar"}
			okText={"Guardar"}
			okButtonProps={{
				form: "form-propiedads",
				key: "submit",
				htmlType: "submit",
			}}
		>
			<ModalAdicionales
				{...props}
				navigate={useNavigate()}
				params={useParams()}
			/>
		</Modal>
	);
}
